module.exports = "/images/cert_olav.82d87.png";